<template>
  <v-navigation-drawer
    app
    :mini-variant="mini"
    @mouseenter.native="showFullMenu"
    class="elevation-8"
    @mouseleave.native="hideFullMenu"
    v-model="drawer"
    stateless
    style="z-index: 8"
    hide-overlay
    fixed
    temporary
  >
    <main-menu-header></main-menu-header>
    <v-list style="white-space:nowrap;">
      <v-list-item :href="externalAddresses('SEARCH')">
        <v-list-item-action>
          <img src="/img/menu-icons/search-engine.svg" alt="" width="28" />
        </v-list-item-action>
        <v-list-item-content>Wyszukiwarka</v-list-item-content>
      </v-list-item>

      <v-list-item :href="externalAddresses('BOOKING')">
        <v-list-item-action>
          <img src="/img/menu-icons/bookings.svg" alt="" width="28" />
        </v-list-item-action>
        <v-list-item-content>Rezerwacje</v-list-item-content>
      </v-list-item>

      <v-list-item to="/delegation">
        <v-list-item-action>
          <img src="/img/menu-icons/business-travel.svg" alt="" width="28" />
        </v-list-item-action>
        <v-list-item-content>Delegacje</v-list-item-content>
      </v-list-item>

      <v-list-item :href="externalAddresses('MY_COMPANY')">
        <v-list-item-action>
          <img src="/img/menu-icons/companies.svg" alt="" width="28" />
        </v-list-item-action>
        <v-list-item-content>Moja firma</v-list-item-content>
      </v-list-item>

      <v-list-item to="/invoices">
        <v-list-item-action>
          <img src="/img/menu-icons/invoice.svg" alt="" width="28" />
        </v-list-item-action>
        <v-list-item-content>Faktury</v-list-item-content>
      </v-list-item>

      <!--<v-list-item :href="externalAddresses('REPORT')">-->
      <!--<v-list-item-action>-->
      <!--<img :src="icons.reportIcon" alt="" width="28">-->
      <!--</v-list-item-action>-->
      <!--<v-list-item-content>Raporty</v-list-item-content>-->
      <!--</v-list-item>-->

      <v-list-item to="/delegation-info">
        <v-list-item-action>
          <img src="/img/menu-icons/travel-policy.svg" alt="" width="28" />
        </v-list-item-action>
        <v-list-item-content>Polityka podróży</v-list-item-content>
      </v-list-item>

      <v-list-item :href="externalAddresses('ACCOUNT_SETTINGS')">
        <v-list-item-action>
          <img src="/img/menu-icons/user-settings.svg" alt="" width="28" />
        </v-list-item-action>
        <v-list-item-content>Ustawienia konta</v-list-item-content>
      </v-list-item>

      <v-list-item to="/logout" v-if="is_user_logged()" style="border-top: 1px solid rgba(0,0,0,.12); margin-top: 8px; padding-top: 8px">
        <v-list-item-action>
          <img src="/img/menu-icons/logout.svg" alt="" width="28" />
        </v-list-item-action>
        <v-list-item-content>Wyloguj się</v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import MainMenuHeader from "./MenuHeader.vue";
import wnbAddresses from "../wnbAddresses";

export default {
  name: "MainMenuWNB",
  components: { MainMenuHeader },
  data() {
    return {
      right: null,
      mini: true,
      drawer: true,
      app: "app",
      hover: null,
      name: null,
      nameRules: null
    };
  },
  computed: {
    isLoggedAs() {
      return this.$store.getters.userProperties != null && typeof this.$store.getters.userProperties.context_user_login !== "undefined";
    },
    can_user_login_as_menu: function() {
      if (typeof this.$store.getters.userProperties !== "undefined" && this.$store.getters.userProperties != null) {
        return this.$store.getters.userProperties.can_login_as;
      }
      return false;
    },
    hasPermissionForInvoices() {
      return this.$store.getters.hasPermission("viewInvoices");
    },
    hasPermissionForBookings() {
      return this.$store.getters.hasPermission("viewBookings");
    }
  },
  methods: {
    showFullMenu: function() {
      this.mini = false;
    },
    hideFullMenu: function() {
      this.mini = true;
    },
    is_user_logged: function() {
      return this.$store.getters.isAuthenticated;
    },
    loginBack: function() {
      this.$store.dispatch("AUTH_LOGIN_BACK");
    },
    externalAddresses: wnbAddresses
  }
};
</script>

<style scoped>
.navigation-drawer--temporary .list__tile__action {
  padding-left: 10px;
}

.v-list__tile__action {
  padding-left: 10px;
}

.v-navigation-drawer--mini-variant .v-list__tile__action {
  padding-left: unset;
}
</style>
